<template>
    <Header></Header>
    <router-view></router-view>
    <PageTop></PageTop>
        <Footer></Footer>

</template>

<script>
import Header from './components/Header.vue'
import PageTop from './components/PageTop.vue'

export default {
  name: 'App',
  components: {
    Header,
    PageTop,
  },
  // setup() {
  //   const routeInstance = this.$route
  //   const createTitleDesc = () => {
  //     if(routeInstance.meta.title) {
  //       let setTitle = routeInstance.meta.title
  //       document.title = setTitle
  //     }
  //   }
    
  //   return {
  //     createTitleDesc
  //   }
  // }

};
</script>

<style>

</style>
